import { useQuery } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";

export const useGetFreebieRuleById = (
    queryKey: string | string[],
    freebieRuleId: string | undefined,
) => {
    const auth = useAuth();

    return useQuery(
        [queryKey, freebieRuleId],
        async () => {
            if (!auth.token) {
                throw new Error(
                    "Cannot fetch freebie rule without authorization token.",
                );
            }

            return await api.freebieRule.fetchFreebieRuleById(
                auth.token,
                freebieRuleId,
            );
        },
        { enabled: freebieRuleId !== "new" && freebieRuleId !== "" },
    );
};
